/* eslint-disable react/no-danger */
/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './additionalInfo.module.scss';

import { renderInfoForType } from '../../../../utils/helpers';
import AttachmentDetail from '../../../../components/customFields/AttachmentDetail';
import FormsMap from '../../../../components/FormsMap';

const AdditionalInformation = ({
  answer,
  fields,
  mergedView,
  linkedField,
  user
}) => {
  const renderWeatherObs = obs => (obs !== undefined
      ? `${obs.metar.summary} - ${obs.metar.temperature}${
          obs.metar.wind !== undefined ? `, ${obs.metar.wind}` : ''
        }${
          obs.metar.humidity !== undefined
            ? `, Humidity - ${obs.metar.humidity}`
            : ''
        }`
      : '');
  const handleDataSourceValue = (dsField, dsValue) => {
    let dsValueDisplay;
    if (dsField.dataSourceID === 'ds10') {
      dsValueDisplay = handleWildlifeSpeciesInfo(dsValue);
      return dsValueDisplay;
    }
    dsValueDisplay = dsValue;
    return dsValueDisplay;
  };

  const handleWildlifeSpeciesInfo = speciesInfo => (
    <div className={styles.wilddiv}>
      <div className={styles.wildLifeFieldsCells}>
        <div className={styles.boldText}>
        <FormattedMessage
          id="wildlife.form.type"
          defaultMessage="Wildlife Type"
        />
        </div>
        <div className={styles.ans}>{speciesInfo.type}</div>
      </div>
      <div className={styles.wildLifeFieldsCells}>
        <div className={styles.boldText}>
        <FormattedMessage
        id="inspections.step2.newField.wildlife_species"
        defaultMessage="Wildlife Species"
      /></div>
        <div className={styles.ans}>{speciesInfo.species}</div>
      </div>
    </div>
  );
  const renderInfoForTypeDetail = (field, value) => {
    switch (field.type) {
      case 'date':
        return renderInfoForType({ 'type': 'date' }, value, null, null);
      case 'wildlife_species':
        return (
        <>
          {handleWildlifeSpeciesInfo(value)}
        </>
        );
      case 'datetime':
        return (
          <>
            {renderInfoForType({ 'type': 'date' }, value, null, null)}
            {' @ '}
            {renderInfoForType({ 'type': 'time' }, value, null, null)}
          </>
        );
      case 'string':
        return <div><pre>{value}</pre></div>;
      case 'number':
        return <div>{value}</div>;
      case 'dataSource':
        return <div>{handleDataSourceValue(field, value)}</div>;
      case 'dataSourceMultiselect':
        return value && value.map(val => <div key={val}>{val}</div>);
      case 'select': {
        const f = answer.version.schema.fields.find(e => e.id === field.id);
        return <div>{f.values.find(e => e.key === value)?.value}</div>;
      }
      case 'multiselect': {
        const f = answer.version.schema.fields.find(e => e.id === field.id);
        return value.map(val => (
          <div key={val}>{f.values.find(e => e.key === val)?.value}</div>
        ));
      }
      case 'attachments': {
        return <div key={value} style={{ width: '700px' }}><AttachmentDetail attachments={value} /></div>;
      }
      default:
        return null;
    }
  };

  return (
    <div>
        <div style={{ fontSize: '25px', fontWeight: 'bold' }}>
            <FormattedMessage
              id="inspections.answer_details.additionalInfo"
              defaultMessage="Additional Information"
            />
        </div>
      <div className={styles.additionalInfo}>
        {Object.keys(fields).filter(item => fields[item].dataSourceID !== 'ds3' && fields[item].dataSourceID !== 'ds4').map(k => (
          <>
            {!mergedView && (
              <>
                {fields[k].type === 'map_location' && user && user?.portal_airport && Object.keys(user?.portal_airport?.location).length > 0 && (
                  <>
                    {fields[k].address_location && (
                      <div key={fields[k].id} className={styles.infoFull}>
                        <span>
                          <FormattedMessage
                            id="customfield.address"
                            defaultMessage="Address"
                          />
                        </span>
                        <p>{answer.response[fields[k].id]?.address}</p>
                      </div>
                    )}
                    {answer.response[fields[k].id] && (
                      <div key={fields[k].id} className={styles.infoMap}>
                        <span style={{ fontWeight: 'bold' }}>
                          {fields[k].title}
                        </span>
                        <div className={styles.map} style={{ marginTop: '20px' }}>
                          <FormsMap
                            shape={fields[k]?.shape}
                            location={answer.response[fields[k].id]}
                            defaultlocation={user?.portal_airport?.location?.coordinates}
                          />
                        </div>
                      </div>
                    )}
                  </>
                )}
                {fields[k].type.includes('MultiLevel') ? (
                  <>
                    {fields[k]?.levels && Object.keys(fields[k]?.levels).map(level => (
                    <div key={fields[k].id} className={styles.field}>
                      <span className={styles.title}>{fields[k]?.levels[level]?.title}</span>
                      <div className={styles.info}>
                        {answer.response[fields[k].id]?.[level]}
                      </div>
                    </div>
                    ))}
                  </>
                ): (
                  <>
                    {fields[k].type !== 'multi_level' && fields[k].type !== 'map_location'
                     && <div key={fields[k].id} className={styles.field}>
                      <span className={styles.title}>{fields[k].title}</span>
                        <div className={styles.info}>
                          {fields[k].type === 'signature'
                            ? (answer.response[fields[k].id] && (
                              <img src={answer.response[fields[k].id][0].url} alt="" />
                            )
                            )
                            : fields[k].type === 'datetime'
                            ? renderInfoForType({ 'type': 'datetime' }, answer.response[fields[k].id], null, null)
                            : (answer.response[fields[k].id]
                              && renderInfoForTypeDetail(fields[k], answer.response[fields[k].id]))
                          }
                        </div>
                        </div>
                    }
                    {fields[k].type === 'multi_level'
                      && answer.response[fields[k].id]
                       && Object.values(answer?.response?.[fields[k].id]).filter(val => val).map((category, index) => (
                        <div key={category} className={styles.field}>
                              <span className={styles.title}>{index === 0 ? `${fields[k]?.title}` : `${fields[k]?.title} ${index}`}</span>
                              <p className={styles.info}>{category}</p>
                        </div>
                    ))
                    }
                  </>
                )}
              </>
            )}
            {mergedView
              && linkedField?.[answer?.version?.form_id] === fields[k].id && (
                <div key={fields[k].id} className={styles.field}>
                  <span className={styles.title}>{fields[k].title}</span>
                  <div className={styles.info}>
                    {answer.response[fields[k].id]
                      && renderInfoForTypeDetail(
                        fields[k],
                        answer.response[fields[k].id]
                      )}
                  </div>
                </div>
              )}
          </>
        ))}
        {answer?.weather_conditions?.current_obs && !mergedView && (
          <div key="weather_obs" className={styles.field}>
            <span className={styles.title}>
              <FormattedMessage
                id="inspections.answer_details.weatherobservation"
                defaultMessage="Weather Observations"
              />
            </span>
            <div
              dangerouslySetInnerHTML={{
                __html: renderWeatherObs(
                  answer?.weather_conditions?.current_obs
                )
              }}
              className={styles.info}
            />
          </div>
        )}
      </div>
    </div>
  );
};

AdditionalInformation.propTypes = {
  answer: PropTypes.shape({}).isRequired,
  fields: PropTypes.shape({}).isRequired
};
export default AdditionalInformation;
